import {
  drawerWidth,
  drawerMiniWidth,
  transition,
  containerFluid,
} from 'assets/jss/material-dashboard-pro-react'

const appStyle = (theme) => ({
  wrapper: {
    top: '0',
    height: '100vh',
    '&:after': {
      display: 'table',
      clear: 'both',
      content: '" "',
    },
  },
  mainPanel: {
    transitionProperty: 'top, bottom, width',
    transitionDuration: '.2s, .2s, .35s',
    transitionTimingFunction: 'linear, linear, ease',
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    overflow: 'auto',
    position: 'relative',
    float: 'right',
    ...transition,
    maxHeight: '100%',
    width: '100%',
    overflowScrolling: 'touch',
  },
  content: {
    marginTop: '70px',
    padding: '15px 40px 15px 15px',
    minHeight: 'calc(100vh - 123px)',
  },
  container: { ...containerFluid },
  map: {
    marginTop: '70px',
  },
  mainPanelSidebarMini: {
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerMiniWidth}px)`,
    },
  },
  mainPanelWithPerfectScrollbar: {
    overflow: 'hidden !important',
  },
  dialogPaper: {
    borderRadius: '12px',
    padding: theme.spacing(2),
  },
  dialogTitle: {
    position: 'relative',
    fontWeight: 600,
    fontSize: '1.25rem',
    color: '#383838',
  },
  dialogContent: {
    padding: theme.spacing(2),
  },
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    backgroundColor: '#EDEDFF',
    padding: '8px',
    borderRadius: '8px',
  },
  counter: {
    backgroundColor: '#6064FF',
    color: '#FFFFFF',
    padding: '3px 6px',
    borderRadius: '4px',
  },
  counterText: {
    fontSize: '12px',
    lineHeight: 1,
    color: '#FFFFFF',
    fontWeight: 700,
  },
  pendingText: {
    fontWeight: 500,
    marginLeft: theme.spacing(1),
    flexGrow: 1,
    fontSize: '16px',
    color: '#383838',
  },
  linkButton: {
    textTransform: 'none',
    fontWeight: 500,
  },
  message: {
    fontSize: '16px',
    marginBottom: theme.spacing(1),
    fontWeight: 400,
  },
  messageName: {
    fontSize: '16px',
    fontWeight: 400,
  },
  boldMessage: {
    fontWeight: 700,
    fontSize: '16px',
    color: '#383838',
    fontFamily: 'Red Hat Display Black',
  },
  gridButtons: {
    marginTop: theme.spacing(2),
  },
  acceptButton: {
    textTransform: 'none',
    fontWeight: 500,
  },
  sizeIcon: {
    marginLeft: '5px',
    fontSize: 20,
  },
  messageRetract: {
    fontWeight: 'bold',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
})

export default appStyle
